import { Button, ButtonVariant, Intent, Popover, Position, Tooltip } from "@blueprintjs/core"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { ILandingConsoleStore, ILandingStore, useLandingConsoleStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import FillPanel from "../fill"
import BorderPanel from "../border"
import useSelectedContent from "src/modules/pe-landing-module/hooks/useSelectedContent"
import { Color } from "src/libs/interfaces/layouts"
import { ILanding, ILandingPrimitive, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { useEffect } from "react"

/* Protopia Ecosystem component */
export interface IColorToolProps {
   
}
const ColorTool = (props: IColorToolProps): JSX.Element => {
    const color = useLandingConsoleStore((state: ILandingConsoleStore) => state.color)
    const border = useLandingConsoleStore((state: ILandingConsoleStore) => state.border)
    const currentLanding: ILanding  = useLandingStore((state: ILandingStore) => state.currentLanding)
    const selectedData              = useSelectedContent()

    const getColor = (): Color => {
        switch (selectedData.type ) {
            case SELECT_TYPE.CONTENT:
                return ""
            case SELECT_TYPE.FLOAT: 
                const primitives: ILandingPrimitive[]   = selectedData.data?.primitives || [] 
                if(!!primitives[0]) {
                    if(!!primitives[0].fill) {
                        return primitives[0].fill || ""
                    }
                }
                else if(!!primitives[1]) {
                    return primitives[1].fill || ""
                } 
                return "" 
            case SELECT_TYPE.TITLE:
                if(selectedData.data?.color) {
                    return selectedData.data.color
                }
                return currentLanding.title?.color || ""
            case SELECT_TYPE.NONE:
            default:
                return color
        }
    }

    useEffect(() => {
        getColor()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ selectedData ])

    const onFill = () => {

    }

    return <div className='landing-color-tool'>
        <Popover
            modifiers={{ 
                arrow: { enabled: true,  options: {padding: 4} },
                flip: { enabled: true },
                preventOverflow: { enabled: false },
                offset: { 
                    enabled: true, 
                    options: {
                        offset: [ 6, 1 ],
                    } 
                }, 
            }}
            position={ Position.RIGHT_TOP }
            content={ <ColorPopoverTool /> }
        >
            <Tooltip 
                content={ <div className="small letter-spacing-1 flex-centered"> 
                    {__( "Fill" )}
                </div> } 
                className=" ml-auto" 
                position="right"
                intent={Intent.PRIMARY}
                compact
                hoverOpenDelay={600}
                portalClassName="z-index-90"
                modifiers={{ 
                    arrow: { enabled: true },
                    flip: { enabled: true },
                    preventOverflow: { enabled: false },
                    offset: { 
                        enabled: true, 
                        options: {
                            offset: [0, 2],
                        } 
                    }, 
                }}
            >
                <Button variant={ ButtonVariant.MINIMAL} onClick={ onFill } >
                    <div className={ `d-flex flex-column align-items-center ` }>
                        <div 
                            style={{
                                width: 30,
                                height: 30,
                                backgroundColor: getColor() || color || "#FFFFFF",
                                boxShadow: "inset 1px 1px 3px 0 #000000AA"
                            }}
                        />
                    </div>
                </Button>
            </Tooltip>
        </Popover>
        <Popover
            modifiers={{ 
                arrow: { enabled: true,  options: {padding: 4} },
                flip: { enabled: true },
                preventOverflow: { enabled: false },
                offset: { 
                    enabled: true, 
                    options: {
                        offset: [ 6, 1 ],
                    } 
                }, 
            }}
            position={ Position.RIGHT_TOP }
            content={ <BorderPopoverTool /> }
        >
            <Tooltip 
                content={ <div className="small letter-spacing-1 flex-centered"> 
                    {__( "Contour" )}
                </div> } 
                className=" ml-auto" 
                position="right"
                intent={Intent.PRIMARY}
                compact
                hoverOpenDelay={600}
                portalClassName="z-index-90"
                modifiers={{ 
                    arrow: { enabled: true },
                    flip: { enabled: true },
                    preventOverflow: { enabled: false },
                    offset: { 
                        enabled: true, 
                        options: {
                            offset: [0, 2],
                        } 
                    }, 
                }}
            >
                <Button variant={ ButtonVariant.MINIMAL} onClick={ onFill } >
                    <div className={ `d-flex flex-column align-items-center ` }>
                        <div 
                            style={{
                                width: 30,
                                height: 30,
                                backgroundColor: border.stroke || "#444444",
                                boxShadow: "inset 1px 1px 3px 0 #000000AA"
                            }}
                            className="flex-centered"
                        >
                            <div 
                                style={{
                                    width: 16,
                                    height: 16,
                                    backgroundColor: "#45526d",
                                    boxShadow: "1px 1px 3px 0 #000000AA"
                                }}
                                className="flex-centered"
                            ></div>
                        
                        </div>
                    </div>
                </Button>
            </Tooltip>
        </Popover>
    </div>
}
export default ColorTool

export const ColorPopoverTool = (): JSX.Element => { 
    return <div className="pe-panel-container px-0 pt-2" style={{  width: 280 }}>
        <FillPanel />
    </div>
}

export const BorderPopoverTool = (): JSX.Element => { 
    return <div className="pe-panel-container px-0 pt-2" style={{ width: 280 }}>
        <BorderPanel />
    </div>
}